// Modules
import React, { useMemo, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// Application
import { useApp } from 'context'

// Components
import { HelpModal, AccountExistsModal, GenericToast } from 'components'
import { Container } from './styles'

// Hooks
import { ROUTES_PATH } from 'constants/routesPath'

type ContainerProviderProps = {
    children: JSX.Element | JSX.Element[]
}

export const ContainerContent: React.FC<ContainerProviderProps> = ({ children }) => {
    const { toast, helpModal, closeHelpModal, closeToast, accountExistsModal, closeAccountExistsModal } = useApp()
    const history = useHistory()
    const { state } = useLocation()

    const redirectTo = useCallback(() => {
        closeToast()
        history.push(toast.link?.to || ROUTES_PATH.LOGIN, state)
    }, [closeToast, history, state, toast.link])

    const toastProps = useMemo(
        () =>
            toast.show
                ? { message: toast.message, onRetry: toast.link ? redirectTo : undefined, onRetryText: toast?.link?.text }
                : undefined,
        [redirectTo, toast],
    )

    return (
        <>
            <Container>
                {toast.show && <GenericToast {...toastProps} />}
                {children}
            </Container>
            {helpModal?.showModal && <HelpModal {...helpModal} setShowModal={closeHelpModal} />}
            {accountExistsModal?.showModal && <AccountExistsModal {...accountExistsModal} setShowModal={closeAccountExistsModal} />}
        </>
    )
}
